//////export * from './segmentation-menu/segmentation-menu.component';
//////export * from './segmentation-menu/segmentation-menu.module';
export * from './segmentation.component';
export * from './segmentation.module';
export * from './segmentation-config/segmentation-config.component';
export * from './segmentation-config/segmentation-config.module';
